module.exports = __webpack_public_path__ + "img/3d-logo-240.6407a88c.png";